import React, { useContext, useState } from "react";

// MUI Components
import { ExpandLess, ExpandMore, RouteOutlined } from "@mui/icons-material";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";

// AWS Components
import { DataStore } from "aws-amplify";
import { Streams } from "../../models";

// Gray Componets
import setActivityLog from "../../utilities/setActivityLog";
import { Application } from "../../context/Application";
import { getTriggers } from "../../utilities/utility";

const AdminTriggerSource = ({ streamData, forceUpdate }) => {
  const global = useContext(Application);

  /* Drop Down Elements */
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /* Admin Tool - Set Stream as Primary for ActiveSB */
  const setTrigger = async (data, config) => {
    const original = await DataStore.query(Streams, (c) =>
      c.and((c) => [c.ssid.eq(+data.ssid), c.station.eq(data.sname.toLowerCase().replace(/-\D\D/, ""))])
    );

    try {
      if (original.length > 0 && original[0].hasOwnProperty("ssid")) {
        /* Update Record */
        // console.log("Update");
        console.log(
          await DataStore.save(
            Streams.copyOf(original[0], (updated) => {
              updated.config = config;
              updated.author = global.appUser.email;
            })
          )
        );
      } else {
        /* Create Record */
        // console.log("Create");
        console.log(
          await DataStore.save(
            new Streams({
              station: data.sname.toLowerCase().replace(/-\D\D/, ""),
              ssid: +data.ssid,
              activesb: data.activesb,
              config: config,
              author: global.appUser.email,
            })
          )
        );
      }

      await setActivityLog({
        type: "TRIGGERS",
        note: `Stream triggering set to ${config} for #${+data.ssid}`,
        author: global.appUser.email,
        station: global.activeStation.station,
      });

      // Refresh Navigation
      forceUpdate();
    } catch (e) {
      console.log("   - ERROR", e);
    }
  };
  return (
    <Box className="admin___panel_button">
      <Box className="title">
        <RouteOutlined fontSize="1rem" />
        <Typography>Trigger Type</Typography>
      </Box>
      <Box className="description">
        <Typography>
          Define the triggering workflow for <b>{streamData.friendly}</b> to help streamline troubleshooting issues.
        </Typography>

        <Typography>
          <b>NOTE:</b> Administrator can still view all streams regardless of visibility setting.
        </Typography>
      </Box>
      <Box className="status">
        <Button
          id="trigger-source-button"
          variant="outlined"
          aria-controls={open ? "trigger-source-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          endIcon={open ? <ExpandLess /> : <ExpandMore />}
          size="small"
        >
          {open ? "Select Trigger Type..." : streamData.config ? getTriggers(streamData.config) : "Select Trigger Type"}
        </Button>
        <Menu
          id="trigger-source-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {[
            { value: "FULLSCTE", name: "Full SCTE" },
            { value: "MIDDLEMAN", name: "MiddleMan" },
            { value: "DBI", name: "Dbi " },
            { value: "TBW", name: "Trigger Based" },
            { value: "TIMED", name: "Timed Scheduling" },
            { value: "SNOWFLAKE", name: "Non-Traditional" },
            { value: "UNDEFINED", name: "Undefined" },
          ].map((item, key) => {
            return (
              <MenuItem
                key={item.value}
                onClick={() => {
                  handleClose();
                  setTrigger(streamData, item.value);
                }}
                sx={{
                  minWidth: "16.25rem",
                  fontSize: "0.875rem",
                  fontWeight: streamData?.config === item.value ? 700 : "inherit",
                  color: streamData?.config === item.value ? "rgba(15, 72, 255, 0.75)" : "inherit",
                }}
              >
                {item.name}
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
    </Box>
  );
};

export default React.memo(AdminTriggerSource);
